import { IMAGE_PLACEHOLDERS } from '@wix/shoutout-email-model-v3';
import { hasPlaceholder } from '@wix/wix-emails-placeholders';
import { getFileExtension } from './get-file-extension';
export const isGif = (src) => /\.gif/.test(src);
export const endsInFileKeyword = (src) => /file$/.test(src);
export const isYoutubeThumbnail = (src) => /youtube/.test(src) || /i\.ytimg/.test(src);
export const getImageWidth = (region, maxContentWidth) => {
    const naturalWidth = region.data.width ? region.data.width : maxContentWidth;
    const imageWidth = naturalWidth >= maxContentWidth ? maxContentWidth : naturalWidth;
    return imageWidth;
};
const MIX_IMAGE_WIDTH = 700;
export const getImageSrc = ({ region, fallbackUrl, maxContentWidth, isMix = false, replaceImagePlaceholders = false, }) => {
    let relativeUri = region.data.relativeUri;
    let src = relativeUri
        ? 'https://static.wixstatic.com/media/' + relativeUri
        : region.data.url || fallbackUrl;
    if (replaceImagePlaceholders && hasPlaceholder(src)) {
        relativeUri = '';
        if (region.data.placeholderPreviewType === 'avatar') {
            src = IMAGE_PLACEHOLDERS.AVATAR;
        }
        else if (isMix) {
            src = IMAGE_PLACEHOLDERS.GENERIC_IN_COLUMN;
        }
        else {
            src = IMAGE_PLACEHOLDERS.GENERIC;
        }
    }
    return [
        {
            condition: supportsVangoghQuery(src) &&
                !isGif(src) &&
                !hasVangoghQuery(src) &&
                !isYoutubeThumbnail(src) &&
                !endsInFileKeyword(src),
            transform: () => {
                if (isMix) {
                    // NOTE: mix image width is 700 and usually image in mix is half of
                    // this width or even less. In result mix already supports retina
                    // images.
                    const imageSrc = getImageUrl(src, MIX_IMAGE_WIDTH, relativeUri);
                    return { src: imageSrc, srcRetina: imageSrc };
                }
                return {
                    src: getNormalImageSrcWidthExactWidth(src, region, maxContentWidth, relativeUri),
                    srcRetina: getNormalImageSrcWidthExactWidth(src, region, maxContentWidth * 2, relativeUri),
                };
            },
        },
        {
            condition: supportsVangoghQuery(src) &&
                !isGif(src) &&
                !endsInFileKeyword(src) &&
                hasVangoghQuery(src),
            transform: () => {
                return {
                    src: getFittedImageSrcWidthExactWidth(src, region, maxContentWidth, isMix),
                    srcRetina: getFittedImageSrcWidthExactWidth(src, region, maxContentWidth * 2, isMix),
                };
            },
        },
        {
            condition: true,
            transform: () => ({ src, srcRetina: src }),
        },
    ].reduce((result, matcher) => {
        if (!(result.src || result.srcRetina) && matcher.condition) {
            return matcher.transform();
        }
        return result;
    }, { src: '', srcRetina: '' });
};
function getNormalImageSrcWidthExactWidth(src, region, maxContentWidth, relativeUri = null) {
    const imageWidth = getImageWidth(region, maxContentWidth);
    return getImageUrl(src, imageWidth, relativeUri);
}
function getFittedImageSrcWidthExactWidth(src, region, maxContentWidth, useMixWidth) {
    const imageWidth = useMixWidth
        ? MIX_IMAGE_WIDTH
        : getImageWidth(region, maxContentWidth);
    return src.split('fit').reduce((url, urlPart, index) => {
        if (index === 1) {
            const updatedWidth = urlPart.replace(/(w_\d+)/, `w_${imageWidth}`);
            return `${url}fit${updatedWidth}`;
        }
        return `${url}${urlPart}`;
    }, '');
}
function supportsVangoghQuery(src) {
    const supports = src.match(/static\.(wixstatic|wix)\.com\/media\/.*/);
    return supports;
}
function hasVangoghQuery(src) {
    return src.match(/\/v1\/.*/);
}
function getImageUrl(src, imageWidth, relativeUri = null) {
    // NOTE: Make sure that ImageWithLoader from composer still works if you change this.
    const imageUrlBase = `${src}/v1/fit/w_${imageWidth},h_2000,al_c,q_85/`;
    if (relativeUri) {
        return `${imageUrlBase}${relativeUri}`;
    }
    const extension = getFileExtension({ src });
    return `${imageUrlBase}image.${extension}`;
}
//# sourceMappingURL=image-utils.js.map